// Room đang mở trong trình thiết kế. Các API đọc giá gửi kèm header X-Room-Id để backend trả giá đã chốt của
// khách gắn với room (nếu có); không có room thì giữ hành vi cũ (giá live).
let activeRoomId = null;

export const setActiveRoomId = roomId => {
  activeRoomId = roomId ? String(roomId) : null;
};

export const getActiveRoomId = () => activeRoomId;

// Nhóm endpoint đọc giá: textures, modules (accessories, handles, chi tiết item) và products (default_setting)
const PRICE_READ_ENDPOINT = /^(textures|modules|products)\/v3\//;

export const roomPriceHeaders = endpoint =>
  activeRoomId && PRICE_READ_ENDPOINT.test(endpoint)
    ? { 'X-Room-Id': activeRoomId }
    : {};
